export default __webpack_public_path__ + "static/media/logo_dalma_blue.c662a417.svg";